// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var Theme = require("./theme");
var React = require("react");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.whiteSpace(/* preLine */538440119),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(20), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* settingButton */settingButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("KonwledgeEntry");

function make(entry, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: flexList
                    }, React.createElement("h1", undefined, "Wissenseintrag"), React.createElement("h1", undefined, Caml_array.caml_array_get(Seed.knowledgeEntries, Caml_format.caml_int_of_string(entry) - 1 | 0)[/* title */1]), React.createElement("p", {
                          className: inputHeader
                        }, Caml_array.caml_array_get(Seed.knowledgeEntries, Caml_format.caml_int_of_string(entry) - 1 | 0)[/* content */2]), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/knowledge");
                            })
                        }, "Zurück")));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/knowledgeEntry.re
// module id = 158
// module chunks = 0